import loadable from '@loadable/component';

const ReviewPrompt = loadable(() =>
  import(/* webpackChunkName: "reviews" */ './prompt')
);

export default ReviewPrompt;
